// Phase 85.A.73 — Messenger inbox + AI assistant API wrappers.
//
// User endpoints (1 conversation per user — auto-create on first GET):
//   GET    /api/messages/me/conversation
//   GET    /api/messages/me/messages?after=ISO
//   POST   /api/messages/me/messages         { text, attachment_urls?: [] }
//   POST   /api/messages/me/mark-read
//
// Admin endpoints (super_admin/admin/organizer):
//   GET    /api/admin/messages?q=...&only_unread=
//   GET    /api/admin/messages/users/search?q=...&limit=8
//   POST   /api/admin/messages/start-chat/{uid}
//   GET    /api/admin/messages/{cid}/messages?after=ISO
//   POST   /api/admin/messages/{cid}/reply   { text, ai_assisted? }
//   POST   /api/admin/messages/{cid}/mark-read
//
// AI assistant endpoints (admin only):
//   POST   /api/admin/support-ai/suggest     { conversation_id, instruction? }
//   GET/POST/PATCH/DELETE /api/admin/support-ai/knowledge
//   POST   /api/admin/support-ai/knowledge/from-message/{mid}
//   GET/PUT /api/admin/support-ai/settings   { away_minutes, auto_bot_text }
import { api } from "./api";

export const messagesUserApi = {
  getConversation: () => api.get("/messages/me/conversation"),
  listMessages: (after = null) =>
    api.get("/messages/me/messages", { params: after ? { after } : {} }),
  sendMessage: (text, attachment_urls = []) =>
    api.post("/messages/me/messages", { text, attachment_urls }),
  markRead: () => api.post("/messages/me/mark-read"),
  // Phase 85.A.77 — Báo backend đã detect screenshot (web heuristic / native).
  reportScreenshot: (source = "web", reason = "") =>
    api.post("/messages/me/screenshot-detected", { source, reason }),
};

export const messagesAdminApi = {
  listInbox: ({ q = "", only_unread = false, limit = 200 } = {}) =>
    api.get("/admin/messages", { params: { q, only_unread, limit } }),
  searchUsers: (q, limit = 8) =>
    api.get("/admin/messages/users/search", { params: { q, limit } }),
  startChat: (userId) => api.post(`/admin/messages/start-chat/${userId}`),
  listMessages: (cid, after = null) =>
    api.get(`/admin/messages/${cid}/messages`, { params: after ? { after } : {} }),
  reply: (cid, text, opts = {}) =>
    api.post(`/admin/messages/${cid}/reply`, { text, ...opts }),
  markRead: (cid) => api.post(`/admin/messages/${cid}/mark-read`),
  // v16.86 — Thu hồi tin nhắn bất kỳ (soft delete) — cả 2 bên không còn thấy.
  recallMessage: (cid, messageId) =>
    api.delete(`/admin/messages/${cid}/messages/${messageId}`),
};

export const supportAiApi = {
  suggest: (conversation_id, instruction = null) =>
    api.post("/admin/support-ai/suggest", { conversation_id, instruction }),
  listKnowledge: (q = "") =>
    api.get("/admin/support-ai/knowledge", { params: q ? { q } : {} }),
  createKnowledge: (data) => api.post("/admin/support-ai/knowledge", data),
  updateKnowledge: (id, data) => api.patch(`/admin/support-ai/knowledge/${id}`, data),
  deleteKnowledge: (id) => api.delete(`/admin/support-ai/knowledge/${id}`),
  promoteMessage: (messageId, title, tags = []) =>
    api.post(`/admin/support-ai/knowledge/from-message/${messageId}`, { title, tags }),
  getSettings: () => api.get("/admin/support-ai/settings"),
  updateSettings: (data) => api.put("/admin/support-ai/settings", data),
  migrateTickets: () => api.post("/admin/support-ai/migrate-tickets"),
};
